module.exports = __webpack_public_path__ + "static/media/money_advice.b6d0fd67.png";